import React from 'react'
import LandingPage from './components/views/LandingPage';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import SingleBlog from './components/views/SingleBlog';
import About from './components/views/About';
// import Shop from './components/views/Shop';
import Blogs from './components/views/Blogs';
// import ShopItem from './components/views/shop/ShopItem';
// import Login from './components/views/auth/Login';
// import Register from './components/views/auth/Register';
// import Cart from './components/views/cart/Cart';
// import ShopCategory from './components/views/shop/ShopCategory';
import BlogItem from './components/views/blog/BlogItem';
import client from './utils/apolloClient'
import { ApolloProvider } from 'react-apollo'
import Error from './components/loaders/Error';
import Search from './components/views/Search';
import Charities from './components/views/Charities';
import Contact from './components/views/Contact';
import SearchPage from './components/views/SearchPage';

const App = () => {
  return (
    <ApolloProvider client={client}> 
      <Router>
        <Switch>
          <Route exact path="/" component={LandingPage}/>
          <Route exact path="/about" component={About}/>
          <Route exact path="/blogs" component={Blogs}/>
          <Route exact path="/blogs/:category" component={BlogItem}/> 
          <Route exact path="/blog/:id" component={SingleBlog}/>
          <Route exact path="/search" component={SearchPage}/>
          <Route exact path="/search/:search" component={Search}/>
          <Route exact path="/advocacy" component={Charities}/>
          <Route exact path="/contact" component={Contact}/>
          {/* <Route exact path="/shop" component={ShopCategory}/>
          <Route exact path="/shop/:category" component={Shop}/>
          <Route exact path="/shop/:category/:id" component={ShopItem}/>
          <Route exact path="/login" component={Login}/>
          <Route exact path="/register" component={Register}/>
          <Route exact path="/cart" component={Cart}/> */}
          <Route exact path="*" component={Error}/>
        </Switch>
      </Router>
    </ApolloProvider>
  )
}

export default App
